import { Route } from "react-router-dom";
import { InvoiceLink } from "./invoiceLink";

export const invoiceLinkRoutes = (
  <>
    <Route path="invoice-link/:secureId" element={<InvoiceLink />} />
  </>
);
